import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import Api from './apis/api'
import axios from 'axios'
import VueAxios from 'vue-axios'

// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
import _ from 'lodash'
Vue(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$Api = Api
Vue.prototype.$axios = axios
Vue.prototype.$VueAxios = VueAxios
Vue.prototype.$_ = _

new Vue({
  // ElementPlus,
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
